import React from 'react';
import { Responsive } from '../../../../responsive/responsive';
import { Grid } from '../../../../grid/grid';
import { Slideshow } from '../../../../swiper/swiper';
import { SkeletonDashboardCardsPortfolioValue } from './portfolio-value/skeleton-dashboard-cards-portfolio-value';
import { SkeletonDashboardCardsRealizedProfit } from './realized-profit/skeleton-dashboard-cards-realized-profit';
import { SkeletonDashboardCardsUnrealizedProfit } from './unrealized-profit/skeleton-dashboard-cards-unrealized-profit';
import { SkeletonDashboardCardsAllTime } from './all-time/skeleton-dashboard-cards-all-time';
import { SkeletonDashboardCardsInvestedValue } from './invested-value/skeleton-dashboard-cards-invested-value';
import { SkeletonDashboardCardsCurrencyImpact } from './currency-impact/skeleton-dashboard-cards-currency-impact';
import { SkeletonDashboardCardsFees } from './fees/skeleton-dashboard-cards-fees';
import { SkeletonDashboardCardsDividends } from './dividends/skeleton-dashboard-cards-dividends';

export const SkeletonDashboardTradesCards: React.FC = () => {
    return (
        <>
            <Responsive breakpoint={'md'} type={'min'}>
                <Grid gap={1.6} cols={{ xs: 1, vl: 2 }}>
                    <Grid gap={1.6} cols={{ xs: 1 }}>
                        <Grid gap={1.6} cols={{ xs: 1, md: 2 }}>
                            <SkeletonDashboardCardsPortfolioValue />
                            <div className="flex h-full flex-col gap-small">
                                <SkeletonDashboardCardsRealizedProfit />
                                <SkeletonDashboardCardsUnrealizedProfit />
                            </div>
                        </Grid>
                        <SkeletonDashboardCardsAllTime />
                    </Grid>
                    <Grid gap={1.6} cols={{ xs: 1 }}>
                        <SkeletonDashboardCardsDividends />
                        <Grid gap={1.6} cols={{ xs: 1, md: 2 }}>
                            <SkeletonDashboardCardsInvestedValue />
                            <div className="flex h-full flex-col gap-small">
                                <SkeletonDashboardCardsCurrencyImpact />
                                <SkeletonDashboardCardsFees />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Responsive>
            <Responsive breakpoint={'md'} type={'max'}>
                <Slideshow>
                    <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                        <SkeletonDashboardCardsPortfolioValue />
                    </div>
                    <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                        <SkeletonDashboardCardsInvestedValue />
                    </div>
                    <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                        <SkeletonDashboardCardsAllTime />
                    </div>
                    <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                        <SkeletonDashboardCardsDividends />
                    </div>
                    <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                        <SkeletonDashboardCardsRealizedProfit />
                        <SkeletonDashboardCardsUnrealizedProfit />
                    </div>
                    <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                        <SkeletonDashboardCardsCurrencyImpact />
                        <SkeletonDashboardCardsFees />
                    </div>
                </Slideshow>
            </Responsive>
        </>
    );
};
